import { render, staticRenderFns } from "./ItemEdit.vue?vue&type=template&id=dd6a8e1c&scoped=true&"
import script from "./ItemEdit.vue?vue&type=script&lang=js&"
export * from "./ItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./ItemEdit.vue?vue&type=style&index=0&id=dd6a8e1c&prod&lang=scss&"
import style1 from "./ItemEdit.vue?vue&type=style&index=1&id=dd6a8e1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6a8e1c",
  null
  
)

export default component.exports